<template>
  <div class="swiper-container home-advertising grayscale"
       id="swiper-container"
       v-show="advertisinglist.length">
    <div class="swiper-wrapper">
      <div class="swiper-slide"
           v-for="(aitem, index) in advertisinglist"
           :key="'keys--' + index">
        <router-link class="item"
                     :to="aitem.url"
                     v-if="aitem.url"><img :src="aitem.img"
               alt="" /></router-link>
        <div v-if="aitem.path"
             class="item"
             @click="toUrl(aitem)">
          <img :src="aitem.img"
               alt="" />
        </div>
        <div class="item"
             v-if="aitem.id"
             @click="showSlidePost(aitem.id)">
          <img :src="aitem.img"
               alt="" />
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>
<script>
export default {
  props: {
    slidesPerView: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    advertisinglist () {
      let arr = []
      const code = this.$point.code
      const extconfig = this.$config.extra_config
        ? JSON.parse(this.$config.extra_config)
        : {}
      const config = extconfig.config || {}
      if (config[code] && config[code].banner && config[code].banner.length) {
        arr = config[code].banner
      }
      arr = extconfig.config['banner']
      if (this.$point.no === 'c22cde1e67c611e9ab49525400436b39') {
        arr.splice(1, 0, {
          id: '6671565a7edc014b99ded913',
          img: 'https://qiniu.laway.cn/yn/2024/06/18/7a9a44ae2d5711ef99e3b4055d0b07be.png',
        })
      }
      return arr
    },
  },
  mounted () {
    this.$nextTick(() => {
      const params = {
        slidesPerView: this.slidesPerView,
        spaceBetween: 40,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }
      if (this.slidesPerView > 1) {
        params.pagination = {
          el: '.swiper-pagination',
          clickable: true,
        }
      }
      new Swiper('#swiper-container', {
        ...params,
      })
    })
  },
  methods: {
    toUrl (item) {
      if (item && item.path) {
        this.$loading.show()
        window.location.href = item.path
      }
    },
  },
}
</script>
<style lang="stylus">
.home-advertising {
  height: 100%;
  .swiper-slide {
    display: flex;
    height: 100%;
  }
  .item {
    height: 1.8rem;
    overflow: hidden;
    display: block;
    width: 100%;
    img {
      flex-shrink: 0;
      width: 100%;
      height: 100%;
    }
  }
  .swiper-pagination-bullet {
    background: #fff;
    width: 20px;
    height: 8px;
    display: inline-block;
    border-radius: 25px;
    opacity: 0.2;
  }
  .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    width: 100%;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #fff;
    width: 0.46rem;
    margin: 0 0.1rem;
    height: 0.08rem;
  }
  .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 0;
  }
  &.radius {
    .item {
      border-radius: 0.1rem;
    }
  }
}
</style>
